import { LoyaltyParticipantTypeEnum, LoyaltyStatusEnum } from 'app/models';

export class IncentiveModel {
    QuestId: number;
    QuestName: string;
    Description: string;
    QuestEnds: string;
    QuestStarts: string;
    Status: LoyaltyStatusEnum;
    Participant: any;
    constructor(
        QuestId: number,
        QuestName: string,
        Description: string,
        QuestEnds: string,
        QuestStarts: string,
        Status: LoyaltyStatusEnum,
        Participant: any
    ) {
        this.Description = Description;
        this.QuestEnds = QuestEnds;
        this.QuestId = QuestId;
        this.QuestName = QuestName;
        this.QuestStarts = QuestStarts;
        this.Status = Status;
        this.Participant = Participant;
    }
}
